import { render } from "./edit-store.vue?vue&type=template&id=75cfadda&scoped=true"
import script from "./edit-store.vue?vue&type=script&lang=js"
export * from "./edit-store.vue?vue&type=script&lang=js"

import "./edit-store.vue?vue&type=style&index=0&id=75cfadda&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cfadda"]])

export default __exports__